import { BaseOption } from 'components/forms/multiSelectField/MultiSelectField.types';
import { MessageLog } from 'models/automation/MessageLogs';
import { useWatch } from 'react-hook-form';

const useSearchedMessageLog = (): string | undefined => {
  const searchedMessageLog: MessageLog[] | BaseOption[] | undefined = useWatch({
    name: 'messageLogSearch',
  });

  if (!searchedMessageLog?.length) {
    return undefined;
  }

  const [chosenMessageLog] = searchedMessageLog;

  return 'label' in chosenMessageLog
    ? chosenMessageLog.label
    : chosenMessageLog.messageName;
};

export default useSearchedMessageLog;
